import { render, staticRenderFns } from "./RegisterToken.vue?vue&type=template&id=cf379360&scoped=true&"
import script from "./RegisterToken.vue?vue&type=script&lang=js&"
export * from "./RegisterToken.vue?vue&type=script&lang=js&"
import style0 from "./RegisterToken.vue?vue&type=style&index=0&id=cf379360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf379360",
  null
  
)

export default component.exports